export const DEFAULT_BORDER_RADIUS = 8;
export const DEFAULT_SPACING = 8;
